import useDocumentTitle from "hooks/useDocumentTitle";
import { TabPanel, TabView } from "primereact/tabview";
import { useState } from "react";

import { HstImportsTab } from "./components/HstImportsTab/HstImportsTab";

// SuperAdmin-only operations for hospital data integrations. One tab per integration;
// add new ones as further TabPanels.
export function Integrations() {
  useDocumentTitle("Integrations");
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="p-4">
      <h1 className="mt-0 mb-3">Integrations</h1>
      <TabView
        activeIndex={activeTab}
        onTabChange={(e) => setActiveTab(e.index)}
      >
        <TabPanel header="HST Imports">
          <HstImportsTab />
        </TabPanel>
      </TabView>
    </div>
  );
}
